import { ComponentProps } from "react";
import { createTheme } from "flowbite-react";

const pTheme = createTheme({
  p: {
    base: "",
    colors: {
      base: "text-foreground",
      muted: "text-muted",
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-destructive",
    },
    sizes: {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
    },
  },
}).p;

type ParagraphProps = {
  children: React.ReactNode
  color?: keyof typeof pTheme.colors
  size?: keyof typeof pTheme.sizes
  className?: string
} & ComponentProps<"p">;

const P = ({
  children,
  color = "base",
  size = "base",
  className = "",
  ...props
}: ParagraphProps) => {
  return (
    <p
      className={`${pTheme.sizes[size]} ${pTheme.colors[color]} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
};

P.displayName = "P";

export { P };
export type { ParagraphProps };
